import React, { useEffect, useState } from "react";
import "./FormBodyMigrantes.scss"

// Components //
import FormMigrantesWizard from "../form-migrantes-wizard/FormMigrantesWizard";
import FormGroupAceleradora from "../form-group-aceleradora/FormGroupAceleradora";
import FormModal from "../../ui/modal/Modal";
import rawToReact from "../../../utils/rawToReact";
import Button from "../../atoms/button/button";
import { navigate } from "gatsby";
import contentfulRenderOptions from "../../../utils/contentfulRenderOption";

interface IBodyFormMigrantes {
    titulosFormulario: Array<any>;
    genericClassNameForm: string;
    setInputValue: any;
    formValues: any;
    handleSubmitForm: any;
    inputDisabled: string[];
    fieldsToSkip?: string[];
    validBirthDate?: boolean;
    isDisabledButton?: boolean;
    handleEvent?: any;
    dateState?: any;
    children?: any;
    talleresData?: any;
    handleCancelButton?: any;
    handleAuthorizationMigP?: any;
    handleAuthorizationMigI?: any;
    modalDeshabiltar: any;
}

const FormBodyMigrantes = (props: IBodyFormMigrantes) => {
    const [activeIndex, setActiveIndex] = useState<number>(0);
    const [wizards, setWizards] = useState<any[]>([]);
    const [displayDeshabiltar, setDisplayDeshabiltar] = useState(true);

    // Si hay mas de un grupo, se activa el wizard y boton VOLVER.
    const activeWizard = props.titulosFormulario.length > 1 ? true : false;

    // Crea lista de los titulos para el wizard
    const createWizards = () => {
        let newWizards: any[] = [];
        for (let i = 0; i < props.titulosFormulario.length; i++) {
            if (props.titulosFormulario[i]) {
                newWizards.push({
                    description: props.titulosFormulario[i].tituloGeneral,
                    idx: i,
                });
            }
        }
        
        setWizards([...newWizards]);
    };

    // Estado para determinar el titulo activo del wizard
    useEffect(() => {
        createWizards();
    }, []);

    const closeModalDeshabilitar = () => {
        navigate(`https://www.comfama.com/servicio-de-empleo/`);
    };


    return (
        <div className="m-form-body-migrantes">
            {/* Renderiza el wizard */}
            <div className="m-form-body-migrantes__wizard">
                {activeWizard && (
                    <FormMigrantesWizard wizards={wizards} activeIndex={activeIndex} />
                )}
            </div>

            {/* Crea grupo el cual contiene secciones y en estas los campos/inputs. */}
            <FormGroupAceleradora
                titulosFormulario={props.titulosFormulario}
                setActiveIndex={setActiveIndex}
                activeIndex={activeIndex}
                activeWizard={activeWizard}
                endIndex={props.titulosFormulario.length}
                setInputValue={props.setInputValue}
                formValues={props.formValues}
                handleSubmitForm={props.handleSubmitForm}
                inputDisabled={props.inputDisabled}
                fieldsToSkip={props.fieldsToSkip}
                validBirthDate={props.validBirthDate}
                isDisabledButton={!!props.isDisabledButton}
                handleEvent={props.handleEvent}
                dateState={props.dateState}
                talleresData={props.talleresData}
                handleCancelButton={props.handleCancelButton}
                handleAuthorizationMigP={props.handleAuthorizationMigP}
                handleAuthorizationMigI={props.handleAuthorizationMigI}
                flagDescrMagentaColor={true}
                flagBotonVolver={true}
                flagGTM="_formulario_migrantes_finalizar"
            />
            {props.children}
            
            {/* Se muestra en el primer paso cuando se desactiva el formulario desde Contentful */}
            {displayDeshabiltar && !props.modalDeshabiltar.formularioMigrantesActivo && activeIndex == 0 && (
                <FormModal showModal={displayDeshabiltar} onClose={closeModalDeshabilitar}>
                <div className="m-modal-content">
                    <div className="m-modal-content__form">
                        <div className="m-modal-content__form__title">
                            {props.modalDeshabiltar.tituloPrincipal}
                        </div>
                        <div className="m-modal-content__form__recuerda">
                            <p>
                                {rawToReact(
                                    props.modalDeshabiltar.descripcion.raw,
                                    contentfulRenderOptions
                                )}
                            </p>
                        </div>
                    </div>
                    <div className="m-modal-content__buttonbar">
                        <Button
                            type="link"
                            text={props.modalDeshabiltar?.tituloBoton}
                            classname={"m-modal-content__buttonbar__back"}
                            isDisabled={false}
                            href={props.modalDeshabiltar?.redireccionBoton}
                        />
                    </div>
                </div>
                </FormModal>
            )}
        </div>
    );
};

export default FormBodyMigrantes;